<mat-form-field appearance="fill" class="w-100">
  <input
    class="form-control"
    type="text"
    matInput
    [formControl]="inputControl"
    #inputField
    [matAutocomplete]="auto"
  />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    <mat-option
      *ngFor="let value of filteredValues$ | async"
      [value]="value.isCreateNew ? inputControl.value : value"
    >
      <ng-container *ngIf="value.isCreateNew; else normalOption">
        <strong>{{ value.label }}</strong>
      </ng-container>
      <ng-template #normalOption>
        <span class="d-flex justify-content-between">
          <span>
            {{ value }}
          </span>
          <span>
            <mat-icon *ngIf="value === params?.value" class="ml-2" color="primary">check</mat-icon>
          </span>
        </span>
      </ng-template>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
